import { useEffect } from 'react';

import envConfig from '../services/env-config';

interface UseAuthRedirectOptions {
    isAuthenticated: boolean;
    status: 'loading' | 'authenticated' | 'unauthenticated';
    includeCurrentUrl?: boolean;
}

export const useAuthRedirect = ({
    isAuthenticated,
    status,
    includeCurrentUrl = true,
}: UseAuthRedirectOptions) => {
    useEffect(() => {
        const basePath = envConfig.BASE_PATH || '/';
        const rawPathname = window.location.pathname;
        const pathname =
            basePath !== '/' && rawPathname.startsWith(basePath)
                ? rawPathname.slice(basePath.length - 1)
                : rawPathname;
        const isAuthRoute = pathname.startsWith('/auth');
        if (status !== 'loading' && !isAuthenticated && !isAuthRoute) {
            const redirectUrl = includeCurrentUrl
                ? `${
                      envConfig.AUTH_SERVICE_SIGNIN
                  }/?callbackUrl=${encodeURIComponent(window.location.href)}`
                : envConfig.AUTH_SERVICE_SIGNIN;

            window.location.href = redirectUrl;
        }
    }, [status, isAuthenticated, includeCurrentUrl]);
};
